import { Routes } from '@angular/router';
import { consultasRoutes } from './consultas/consultas.routes';
import { solicitudesRoutes } from './solicitudes/solicitudes.routes';
import { importacionRoutes } from './importacion/importacion.routes';
import { gestionRoutes } from './gestion/gestion.routes';

export const modulosLayoutRoutes: 
    Routes = [
        ...consultasRoutes,
        ...solicitudesRoutes,
        ...gestionRoutes,
        ...importacionRoutes,
    ];
